import React, { useRef, useEffect } from "react";
import { FiSend } from "react-icons/fi";
import useAIChat from "../hooks/useAIChat";
import MessageBubble from "../components/MessageBubble";

export default function AIChatPage() {
  const bottomRef = useRef(null);
  const {
    messages,
    input,
    setInput,
    loading,
    suggestionChips,
    handleSend,
    handleQuickPrompt,
    handleButtonClick, // (optional, not used here)
    handleConfirm,
    sendPrompt,
    handleDisambiguationConfirm,
    handleDisambiguationReject,
  } = useAIChat();

  // Handler for AI "smart" chip/button clicks
  const handleChipPrompt = (prompt) => {
    // Always lowercase for AI, unless it's a structured command
    handleSend(prompt);
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  const onUserSend = () => {
    handleSend();
  };

  return (
    <div className="flex flex-col h-screen bg-gradient-to-br from-white via-gray-50 to-gray-100">
      <header className="px-6 py-4 border-b bg-white shadow-sm">
        <h1 className="text-xl font-semibold text-gray-800">💼 HyperCRM Copilot</h1>
        <p className="text-xs text-gray-500">
          Ask anything about clients, invoices, tasks, and more.
        </p>
      </header>

      <main className="flex-1 overflow-y-auto px-6 py-4 space-y-4 bg-white/60 backdrop-blur-sm">
        {messages.map((msg, idx) => (
          <MessageBubble
            key={idx}
            message={msg}
            time={msg.time}
            handleConfirm={handleConfirm}
            onDisambiguationConfirm={handleDisambiguationConfirm}
            onDisambiguationReject={handleDisambiguationReject}
            onChipPrompt={handleChipPrompt} // <--- enable smart AI "buttons"
          />
        ))}
        {loading && (
          <div className="text-sm italic text-gray-400">AI is thinking…</div>
        )}
        <div ref={bottomRef} />
      </main>

      <footer className="border-t bg-white px-4 py-3 shadow-inner">
        <div className="flex flex-col gap-2">
          <div className="flex flex-wrap gap-2">
            {suggestionChips.map((chip, i) => (
              <button
                key={i}
                className="text-xs px-3 py-1 border rounded-full hover:bg-blue-100"
                onClick={() => handleQuickPrompt(chip)}
              >
                💡 {chip}
              </button>
            ))}
          </div>
          <div className="flex items-center space-x-2">
            <input
              type="text"
              className="flex-1 px-4 py-2 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Type a request like 'create invoice for Shivani for $250 due Friday…'"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onUserSend()}
              disabled={loading}
            />
            <button
              className="p-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white"
              onClick={onUserSend}
              disabled={loading}
            >
              <FiSend className="h-5 w-5" />
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}
